var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-input-select',_vm._g(_vm._b({attrs:{"fullwidth":"","options":_vm.options},on:{"input":function($event){return _vm.$emit('input', $event)}}},'m-input-select',_vm.$attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }